<script xmlns="http://www.w3.org/1999/html">
export default {
  name: "Header",
  props: ['screenWidth'],
  data() {
    return{
      menuList: [
        {name: '首页', index: '1'},
        {name: '关于欧力泰', index: '2'},
        {name: '明星产品', index: '3'},
        {name: '新闻动态', index: '4'},
        {name: '联系我们', index: '5'},
      ],
      activeIndex: this.$route.query.activeIndex ? this.$route.query.activeIndex : '1',
      menuShow: false
    }
  },
  methods: {
    goPage(item){
      let key = item.index
      if (key === '1' && this.$route.query.activeIndex !== key) {
        this.$router.push({ path: '/', query:{activeIndex: key} })
      }else if(key === '2' && this.$route.query.activeIndex !== key){
        this.$router.push({ path: '/olt', query:{activeIndex: key} })
      } else if (key === '3' && this.$route.query.activeIndex !== key) {
        this.$router.push({ path: '/star', query:{activeIndex: key} })
      }else if(key === '4' && this.$route.query.activeIndex !== key){
        this.$router.push({ path: '/news', query:{activeIndex: key} })
      } else if (key === '5' && this.$route.query.activeIndex !== key) {
        this.$router.push({ path: '/contact', query:{activeIndex: key} })
      }
    },
    menuClick(){
      this.menuShow = !this.menuShow
    }
  }
}
</script>

<template>
  <div>
    <div class="header-main" v-if="screenWidth > 1080">
      <div class="header-left">
        <img class="header-log-img" src="https://olt-img.oss-cn-beijing.aliyuncs.com/header/header-logo.png"/>
        <div class="company-name-main">
          <div class="company-name">荷兰欧力泰植物营养科技有限公司</div>
          <div class="company-simple">养分极速渗透 根际火速吸收</div>
        </div>
      </div>

      <div class="header-right">
        <img class="header-phone" src="https://olt-img.oss-cn-beijing.aliyuncs.com/header/phone.png"/>
        <div style="display: flex;align-items: center;margin-left: 3px">
          <span class="phonetext">服务热线</span>：<span class="phone">400-666-5628</span>
        </div>
      </div>
    </div>

    <div class="menu-phone" v-else>
      <div class="header-main-phone">
        <div class="header-left">
          <img class="header-log-img" src="https://olt-img.oss-cn-beijing.aliyuncs.com/header/header-logo.png"/>
          <div class="company-name-main">
            <div class="company-name">荷兰欧力泰植物营养科技有限公司</div>
            <div class="company-simple">养分极速渗透 根际火速吸收</div>
          </div>
        </div>

        <div class="header-right" @click="menuClick">
          <img v-if="!menuShow" class="header-phone" src="https://olt-img.oss-cn-beijing.aliyuncs.com/header/menu.png"/>
          <img v-else class="header-close" src="https://olt-img.oss-cn-beijing.aliyuncs.com/header/close-2.png"/>
        </div>
      </div>
      <div class="header-menu" v-show="menuShow">
        <div class="menu-box">
          <div class="menu-item" @click="goPage(item)" v-for="(item, index) in menuList" :key="index">
            <span>{{item.name}}</span>
            <div class="drive" :class="[item.index === activeIndex ? 'drive-active' : '']"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "./css/header-phone.scss";

@media (max-width: 1080px) {
  .company-name {
    font-size: 14px;
  }

  .header-phone {
    width: 28px;
    height: 28px;
  }

  .header-close{
    width: 28px;
    height: 28px;
  }

  .phonetext {
    font-family: 'Noto Sans SC';
    font-size: 15px;
  }

  .phone {
    font-family: 'Noto Sans SC';
    font-size: 24px;
    font-weight: 700;
  }

  .header-log-img {
    width: 48px;
    height: 64px;
  }

  .company-name {
    font-weight: 700;
    font-size: 20px;
  }

  .company-simple {
    font-size: 15px;
  }
}

@media (min-width: 1081px) {
  .responsive-font {
    font-size: 20px; /* 大屏幕的字体大小 */
  }

  .header-main {
    padding: 16px clamp(10px, 5%, 260px);
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    text-align: left;
    color: #000000;
    min-width: 1024px;

    .header-left {
      display: flex;
      align-items: center;
    }

    .company-name-main {
      margin-left: 20px;
    }

    .header-right {
      display: flex;
      align-items: center;
      justify-content: right;
    }

  }

  .header-phone {
    width: 21px;
    height: 21px;
  }

  .phonetext {
    font-family: 'Noto Sans SC';
    font-size: 15px;
  }

  .phone {
    font-family: 'Noto Sans SC';
    font-size: 24px;
    font-weight: 700;
  }

  .header-log-img {
    width: 47px;
    height: 63px;
  }

  .company-name {
    font-weight: 700;
    font-size: 20px;
  }

  .company-simple {
    font-size: 15px;
  }
}


</style>
